<script setup lang="ts">
import { ref, useId } from 'vue';

interface Props {
  text: string;
}

const props = defineProps<Props>();

const tooltipId = useId();
const open = ref(false);

function show(): void {
  if (!props.text) return;
  open.value = true;
}

function hide(): void {
  open.value = false;
}
</script>

<template>
  <span
    class="relative inline-block"
    tabindex="0"
    :aria-describedby="open ? tooltipId : undefined"
    @mouseenter="show"
    @mouseleave="hide"
    @focusin="show"
    @focusout="hide"
  >
    <slot />
    <span
      v-if="open"
      :id="tooltipId"
      role="tooltip"
      class="absolute right-full -top-1 z-50 mr-1.5 whitespace-nowrap rounded-small bg-text-primary px-sm py-xs text-label-medium text-bg-page shadow-flat-card duration-fast ease-out"
    >
      {{ text }}
    </span>
  </span>
</template>